module.exports = __webpack_public_path__ + "img/kpmg.11a0f15b.jpg";